import React from 'react';
import { RevealOnScroll } from '../ui/RevealOnScroll';
import { TextLink } from '../ui/TextLink';
export function Practice() {
  return <section id="practice" className="bg-ink py-24 md:py-32 px-6" data-id="element-141">
      <div className="container mx-auto max-w-6xl" data-id="element-142">
        <RevealOnScroll className="text-center mb-24 md:mb-32" data-id="element-143">
          <p className="font-mono text-[12px] tracking-[0.2em] uppercase text-brass mb-6" data-id="element-144">
            CHAPTER TWO. THE PRACTICE.
          </p>
          <h2 className="font-serif italic text-white text-4xl md:text-[48px]" data-id="element-145">
            Three ways to begin a story together.
          </h2>
        </RevealOnScroll>

        <div className="flex flex-col gap-[120px] md:gap-[160px]" data-id="element-146">
          {/* Row I */}
          <RevealOnScroll data-id="element-147">
            <div className="flex flex-col md:flex-row items-center gap-12 md:gap-24" data-id="element-148">
              <div className="w-full md:w-[40%] order-1 md:order-1" data-id="element-149">
                <div className="relative p-2 border border-brass/30" data-id="element-150">
                  <img src="https://cdn.magicpatterns.com/uploads/wAuX5yUU4KC61vZaY6LBQ5/furniture-refresh-spaces.jpg" alt="A single chair in a forest clearing" className="w-full aspect-[3/4] object-cover" data-id="element-151" />
                </div>
              </div>
              <div className="w-full md:w-[60%] order-2 md:order-2" data-id="element-152">
                <span className="font-mono text-brass text-[14px] block mb-4" data-id="element-153">
                  I.
                </span>
                <h3 className="font-serif italic text-parchment text-3xl md:text-[36px] mb-4" data-id="element-154">
                  The Furniture Refresh.
                </h3>
                <p className="font-mono text-parchment text-[14px] mb-6" data-id="element-155">
                  A new picture within the existing frame.
                </p>
                <p className="font-mono text-parchment/70 text-[13px] leading-[1.8] mb-8 max-w-lg" data-id="element-156">
                  We begin by listening to the rooms you already have. Some
                  pieces only need to be reimagined or relocated. Others ask to
                  be retired. We curate what remains, and we welcome what is
                  missing.
                </p>
                <TextLink href="#contact" className="text-brass" underlineColor="border-brass" data-id="element-157">
                  read more &rarr;
                </TextLink>
              </div>
            </div>
          </RevealOnScroll>

          {/* Row II */}
          <RevealOnScroll data-id="element-158">
            <div className="flex flex-col md:flex-row items-center gap-12 md:gap-24" data-id="element-159">
              <div className="w-full md:w-[60%] order-2 md:order-1 md:text-right md:flex md:flex-col md:items-end" data-id="element-160">
                <span className="font-mono text-brass text-[14px] block mb-4" data-id="element-161">
                  II.
                </span>
                <h3 className="font-serif italic text-parchment text-3xl md:text-[36px] mb-4" data-id="element-162">
                  The Remodel.
                </h3>
                <p className="font-mono text-parchment text-[14px] mb-6" data-id="element-163">
                  Architecture, function, and beauty in conversation.
                </p>
                <p className="font-mono text-parchment/70 text-[13px] leading-[1.8] mb-8 max-w-lg" data-id="element-164">
                  From reimagined layouts to new architectural finishes, every
                  detail is considered. Floor plans, fixture selections,
                  cabinetry concepts, and the quiet collaboration with
                  architects and contractors who bring it all to life.
                </p>
                <TextLink href="#contact" className="text-brass" underlineColor="border-brass" data-id="element-165">
                  read more &rarr;
                </TextLink>
              </div>
              <div className="w-full md:w-[40%] order-1 md:order-2" data-id="element-166">
                <img src="https://cdn.magicpatterns.com/uploads/1fLemNq2Yfsfu4uC15NgU1/remodel-spaces.jpg" alt="Moodboard with fabric swatches and tile" className="w-full aspect-[4/5] object-cover" data-id="element-167" />
              </div>
            </div>
          </RevealOnScroll>

          {/* Row III */}
          <RevealOnScroll data-id="element-168">
            <div className="flex flex-col md:flex-row items-center gap-12 md:gap-24" data-id="element-169">
              <div className="w-full md:w-[40%] order-1 md:order-1" data-id="element-170">
                <img src="https://cdn.magicpatterns.com/uploads/d4cVjwxHib1AjCASLGCprn/design-consultation-spaces.jpg" alt="Anna with chair on a forest path" className="w-full aspect-[3/4] object-cover" data-id="element-171" />
              </div>
              <div className="w-full md:w-[60%] order-2 md:order-2" data-id="element-172">
                <span className="font-mono text-brass text-[14px] block mb-4" data-id="element-173">
                  III.
                </span>
                <h3 className="font-serif italic text-parchment text-3xl md:text-[36px] mb-4" data-id="element-174">
                  The Design Consultation.
                </h3>
                <p className="font-mono text-parchment text-[14px] mb-6" data-id="element-175">
                  A fresh set of eyes. A focused conversation.
                </p>
                <p className="font-mono text-parchment/70 text-[13px] leading-[1.8] mb-8 max-w-lg" data-id="element-176">
                  Sometimes a single afternoon together is all a space needs. We
                  walk through your home, identify what is working and what is
                  not, and leave you with a clear direction. For those who want
                  professional insight without a full-scale engagement.
                </p>
                <TextLink href="#contact" className="text-brass" underlineColor="border-brass" data-id="element-177">
                  read more &rarr;
                </TextLink>
              </div>
            </div>
          </RevealOnScroll>
        </div>
      </div>
    </section>;
}